import { render, staticRenderFns } from "./YearlyReportTable.vue?vue&type=template&id=2dd80820&"
import script from "./YearlyReportTable.vue?vue&type=script&lang=js&"
export * from "./YearlyReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports